// extracted by mini-css-extract-plugin
export default {"container":"ObjectSelector_container__7Bx23","spin":"ObjectSelector_spin__QxQY-"};